export default __webpack_public_path__ + "static/media/package2.52ee8288.png";